import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=52e49618&scoped=true"
import script from "./DeliveryList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=52e49618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e49618",
  null
  
)

export default component.exports